<div class="w-full padding_20" *ngIf="hasConfiguration">
  <div style="color: #475569;" class="mb-[1rem]">
    <div class="flex flex-row justify-between align-middle items-center">
      <h1 class="uppercase text-[#475569] font-bold text-3xl lg:text-4xl">{{"global conf" | translate }}</h1>
    </div>
  </div>

  <br>

  <div class="flex lg:flex-row flex-col gap-[2rem] mt-[2rem] w-full">
    <!-- EDIT MODAL 1 -->
    <div class="wrapper-conf bg-white w-full rounded-xl shadow-sm border-solid border-[0.025rem] p-7">
      <div class="flex flex-row justify-between" style="gap: 3em">
        <h1 class="title-conf">{{ "Working days and hours" | translate }}</h1>
        <button (click)="toggleEditWorkingHoursPopup(true)">
          <i style="font-size: 2rem" class="fa-regular fa-edit"></i>
        </button>
      </div>

      <div style="background-color: #373737; height: 0.5px; width: 80px"></div>

      <div class="flex flex-col gap-2">
        <div *ngFor="let group of sortedWorkingHours">
          <div class="flex flex-row justify-start gap-5 w-full">
           
            <div class="flex flex-row justify-start gap-3 w-1/2">
              {{ translate("DaysOfWeek." + group[0].dayOfWeek?.toString()) }}
              <div class="flex flex-row gap-3" *ngIf="group.length > 1">
                <p>-</p>
                <p>{{translate("DaysOfWeek." + group[group.length - 1].dayOfWeek?.toString())}} </p>
              </div>
            </div>

            <div class="w-1/2 flex flex-row justify-end font-semibold">
              <p>
                {{ group[0].fromTime | date : "HH:mm" }} -
                {{ group[group.length - 1].toTime | date : "HH:mm" }}
              </p>
            </div>
            
          </div>
        </div>
      </div>
    </div>

    <!-- EDIT MODAL 2 -->
    <div class="wrapper-conf bg-white w-full rounded-xl shadow-sm border-solid border-[0.025rem] p-7">
      <div class="flex flex-row justify-between min-h-[3.15rem]" style="gap: 3em">
        <h1 class="title-conf">{{ "Term Frequency" | translate }}</h1>
        <button (click)="editTimeBetweenGeneratedTermsInMinutes(timeBetween.value)">
          <i *ngIf="!isEditTimeBetweenGeneratedTermsOpen" style="font-size: 2rem" class="fa-regular fa-edit"></i>
          <i *ngIf="isEditTimeBetweenGeneratedTermsOpen" style="font-size: 2.15rem" class="fa-regular fa-floppy-disk"></i>
        </button>
      </div>

      <div style="background-color: #373737; height: 0.5px; width: 80px"></div>

      <p class="min-h-[2rem]"> {{"on every" | translate }} <input #timeBetween type="number" [value]="currentConfigurationData?.timeBetweenGeneratedTermsInMinutes"
        class="mx-[.5rem] w-[4rem] h-[2rem] text-center text-black transition-all duration-300 ease-in-out" [ngClass]="{
            'cursor-default pointer-events-none select-none font-bold mr-[-1rem]': !isEditTimeBetweenGeneratedTermsOpen,
            'cursor-auto pointer-events-auto select-auto editing_anim': isEditTimeBetweenGeneratedTermsOpen
          }" (keyup.enter)="saveTimeBetweenGeneratedTermsInMinutes(timeBetween.value)" /> {{"min" | translate }}
      </p>
    </div>

    <!-- EDIT MODAL 3 -->
    <div class="wrapper-conf bg-white w-full rounded-xl shadow-sm border-solid border-[0.025rem] p-7">
      <div class="flex flex-row justify-between min-h-[3.15rem]" style="gap: 3em">
        <h1 class="title-conf">{{ "Duration of break between two terms" | translate }}</h1>
        <button (click)="editPauseTimeAfterTermsInMinutes(pauseTimeAfterTerms.value)">
          <i *ngIf="!isEditPauseTimeAfterTermsInMinutes" style="font-size: 2rem" class="fa-regular fa-edit"></i>
          <i *ngIf="isEditPauseTimeAfterTermsInMinutes" style="font-size: 2.15rem" class="fa-regular fa-floppy-disk"></i>
        </button>
      </div>

      <div style="background-color: #373737; height: 0.5px; width: 80px"></div>

    <p class="min-h-[2rem]"> {{"break between two terms" | translate }} <input #pauseTimeAfterTerms type="number" [value]="currentConfigurationData?.pauseTimeAfterTermsInMinutes"
      class="mx-[.5rem] w-[4rem] h-[2rem] text-center text-black transition-all duration-300 ease-in-out" [ngClass]="{
          'cursor-default pointer-events-none select-none font-bold mr-[-1rem]': !isEditPauseTimeAfterTermsInMinutes,
          'cursor-auto pointer-events-auto select-auto editing_anim': isEditPauseTimeAfterTermsInMinutes
      }" (keyup.enter)="savePauseTimeAfterTermsInMinutes(pauseTimeAfterTerms.value)" /> {{"min" | translate }} </p>
    </div>

  </div>
</div>

<!-- WorkingHours pop-up -->
<app-generic-modal *ngIf="editWorkingHoursPopupState && hasConfiguration"
    [modal_state_function]="toggleEditWorkingHoursPopup"
    [bannerText]="'Working days and hours' | translate"
    [handle_extreme_overflow]="false"
    (handleCloseEmitter)="toggleEditWorkingHoursPopup(false)">
  <!-- Main Hours Config Form -->
  <form class="flex flex-col gap-[1.35rem] mt-[.5rem] w-full justify-center align-middle sm:max-w-[50rem]" *ngIf="!hasBookedTermsInChange" (ngSubmit)="$event.preventDefault()">

    <div class="flex flex-col gap-5">

      <div *ngFor="let workingHourConfig of originalWorkingHourConfigs">
        <div class="flex flex-row justify-between gap-5 w-full">
          <div class="flex flex-col justify-center self-center align-middle w-1/3 text-start">

            <p class="text-[#373737] uppercase font-bold text-[1.05rem] sm:text-[1.35rem]">
              {{translate("DaysOfWeekFull." + workingHourConfig.dayOfWeek?.toString())}}
            </p>

            <div class="flex flex-row gap-5 mt-[.5rem]">
              <label class="relative inline-flex items-center cursor-pointer">
                <input #toggle type="checkbox"
                [value]="workingHourConfig.working"
                [checked]="workingHourConfig.working"
                (change)="workingHourConfig.working = !workingHourConfig.working; hasEditedHours = true"
                class="sr-only peer">
                <div
                  class="w-[3rem] h-[1.65rem] bg-gray-200 peer-focus:outline-none
                  peer-focus:ring-2 peer-focus:ring-[rgba(255,255,255,0.15)] rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#2c99b1]"></div>
              </label>

              <p class="font-normal text-[1rem] sm:text-[1.3rem] text-red-500 select-none hover:text-gray-500"
                  (click)="workingHourConfig.working = !workingHourConfig.working; hasEditedHours = true"
                  *ngIf="!workingHourConfig.working">
                {{"day not working" | translate}}
              </p>

              <p class="font-normal text-[1rem] sm:text-[1.3rem] text-gray-500 select-none hover:text-red-500"
                  (click)="workingHourConfig.working = !workingHourConfig.working; hasEditedHours = true"
                  *ngIf="workingHourConfig.working">
                {{"day working" | translate}}
              </p>

            </div>
          </div>

          <div class="flex flex-row w-2/3 justify-end self-end align-left items-end gap-5">
            <input #fromTime type="time" [value]="workingHourConfig.fromTime | date : 'HH:mm'" step="900"
              class="py-[.5rem] sm:py-[1rem] px-[1rem] sm:px-[1.5rem] border-[1px] rounded-lg w-[15rem] text-center text-black" [ngClass]="{
                  'opacity-50 border-black/50 cursor-default pointer-events-auto select-auto':
                    workingHourConfig.working,
                  'opacity-70 border-red-500 text-black/50 cursor-default pointer-events-none select-none':
                    !workingHourConfig.working
                }" (keyup.enter)="
                  updateFromTimeEditList(fromTime.value, workingHourConfig)
                " (blur)="
                  updateFromTimeEditList(fromTime.value, workingHourConfig)
                " />

            <div class="w-[2.5rem] h-[1px] bg-black self-center"></div>

            <input #toTime type="time" [value]="workingHourConfig.toTime | date : 'HH:mm'" step="900"
              class="py-[.5rem] sm:py-[1rem] px-[1rem] sm:px-[1.5rem] border-[1px] rounded-lg w-[15rem] text-center text-black" [ngClass]="{
                  'opacity-50 border-black/50 cursor-default pointer-events-auto select-auto':
                    workingHourConfig.working,
                  'opacity-70 border-red-500 text-black/50 cursor-default pointer-events-none select-none':
                    !workingHourConfig.working
                }" (keyup.enter)="
                  updateToTimeEditList(toTime.value, workingHourConfig)
                " (blur)="updateToTimeEditList(toTime.value, workingHourConfig)" />
          </div>
        </div>
      </div>

    </div>

    <div class="bg-[#F9DEC0] rounded-md p-3 flex flex-row justify-between align-middle items-center gap-5 text-[#D94E4E] transition-all duration-200 ease-in-out"
    [ngClass]="{'select-none opacity-35': !hasEditedHours}">
      <div>
        <svg class="w-[22px] sm:w-[32px] h-[22px] sm:h-[32px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
          <path fill="#D94E4E" d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
        </svg>
      </div>
      <div class="text-[0.85rem] sm:text-[1.35rem] w-full"> {{"Changes to the global configuration affect" | translate }} </div>
    </div>

    <div class="w-full flex flex-row gap-[0.85rem] justify-between align-middle items-center text-black">
      <mat-checkbox #confirmatioCheckbox [aria-label]="'confirmationCheckboxMobile'" class="text-wrap font-normal" [disabled]="!hasEditedHours"></mat-checkbox>
      <p class="text-[0.85rem] sm:text-[1.35rem] w-full " [ngClass]="{'select-none opacity-35': !hasEditedHours}">{{"agreement changes" | translate }}</p>
    </div>

    <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem]">
      <button (click)="toggleEditWorkingHoursPopup(false); $event.preventDefault()"
        class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] bg-[#dadada] uppercase text-[#696767] hover:bg-[#c4c4c4] shadow-md active:scale-[0.985] active:shadow-sm">
        {{ "BACK" | translate }}
      </button>

      <button [disabled]="!hasEditedHours || !confirmatioCheckbox.checked" [ngClass]="{
            'bg-[#b98d78] hover:bg-[#a57d6a] active:scale-[0.985] active:shadow-sm': hasEditedHours && confirmatioCheckbox.checked,
            'bg-[#b98d78]/20 hover:bg-[#a57d6a]/20': !hasEditedHours || !confirmatioCheckbox.checked
          }" (click)="prepareSaveWorkingHours(); $event.preventDefault()" class="w-1/2 px-5 uppercase py-[.5rem] rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm">
       {{"Save changes" | translate }}
      </button>
    </div>

  </form>

  <!-- Warning Message -->
  <div class="flex flex-col justify-center gap-[1rem] items-center align-middle md:max-w-[50rem]" *ngIf="hasBookedTermsInChange">
    <div class="questionmark_icon w-[8rem] h-[8rem] self-center mt-[-1rem]"> </div>

    <div class="bg-[#F9DEC0] rounded-md p-3 flex flex-row justify-between align-middle items-center gap-3 text-[#D94E4E]">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
            <path fill="#D94E4E" d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
          </svg>
        </div>
        <div class="text-[1.25rem]"> {{"if make changes terms will be cancelled" | translate }} </div>
    </div>

    <div class="p-[1.5rem] border-2 border-[#B98D78] w-full h-full rounded-lg flex flex-col gap-5 overflow-auto max-h-[30rem] text-black">
        <div *ngFor="let term of negatedTermsToCancel" class="flex flex-col gap-2 bg-[#f7f7f8] p-3 shadow-sm rounded-md">
          <div class="flex flex-row gap-1">
            <div class="uppercase text-[1.5rem] font-bold text-black">{{ term.serviceName }}</div>
            <div> {{"-"}} {{ term.fromDate | date : 'dd.MM.yyyy' }} {{"|"}} {{ term.fromDate | date : 'HH:mm' }} - {{ term.toDate | date : 'HH:mm' }}</div>
          </div>

          <div class="flex flex-col gap-2">
            <div class="flex flex-row gap-1 text-[#B98D78]">
              <div class="text-[#767474]"> {{"client" | translate }} </div>
              <div> {{ term.name }} {{ term.surname }} </div>
            </div>

            <div class="flex flex-row gap-1">
              <div class="text-[#767474]"> {{"employee" | translate }} </div>
              <div class="italic"> {{ term.employeeName }} {{ term.employeeSurname }} </div>
            </div>
          </div>

        </div>
    </div>

    <div class="flex flex-row gap-10 w-full">
      <button (click)="hasBookedTermsInChange = false; $event.preventDefault()"
        class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] bg-[#dadada] hover:bg-[#c4c4c4] active:scale-[0.985] uppercase shadow-md active:shadow-sm text-[#696767]">
        {{ "BACK" | translate }}
      </button>

      <button (click)="saveWorkingHoursAndCancel(); $event.preventDefault()" class="bg-[#2c99b1] hover:bg-[#378da0] uppercase active:scale-[0.985] shadow-md active:shadow-sm w-1/2 px-5 py-[.5rem] rounded-[.25rem] text-white">
        {{"Save changes" | translate }}
      </button>
    </div>
  </div>

</app-generic-modal>

